import { useApiCall } from "@/app/api/apiCall";
import { ListFieldsOptionsApiCall } from "@/app/api/types";
import { SelectFieldFilterOptions } from "@/app/components/filters/SelectFieldFilterOptions";
import { LoadingSelectFilter } from "@/app/components/LoadingSelectFilter";
import { ISelectFieldOption } from "@/app/fields/types";
import { useSyncedParamValues } from "@/app/hooks/useSyncedParams";
import {
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Box,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

export function SelectFieldFilter({
  label,
  getFieldOptions,
  field,
  isDisabled,
}: {
  getFieldOptions: ListFieldsOptionsApiCall;
  field: string;
  label: string;
  isDisabled: boolean;
}) {
  const [values, setValues] = useSyncedParamValues(field);
  const [options, setOptions] = useState<ISelectFieldOption[] | undefined>();
  const handle = useApiCall();
  const fetchOptions = async () => {
    await handle(
      () => getFieldOptions(field),
      (response) => setOptions(response.results)
    );
  };
  useEffect(() => {
    fetchOptions();
  }, []);
  return (
    <>
      <AccordionButton>
        <Box as="span" flex="1" textAlign="left">
          {label}
          {!!values.length ? ` (${values.length})` : ""}
        </Box>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel
        maxHeight="400px"
        overflowY="scroll"
        className="no-scrollbar"
        data-cy={`options-panel-${field}`}
      >
        {!!options ? (
          <SelectFieldFilterOptions
            isDisabled={isDisabled}
            options={options}
            values={values}
            setValues={setValues}
          />
        ) : (
          <LoadingSelectFilter />
        )}
      </AccordionPanel>
    </>
  );
}
